'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('../../util/validators/password-validator.js');
require('../../util/helpers/strings.js');
require('../../util/helpers/date.js');
require('../../util/helpers/arrays.js');
require('../../util/helpers/language.js');
require('../../util/helpers/numbers.js');
var Component = require('vue-class-component');
var Component__default = _interopDefault(Component);
require('../../util/helpers/currency.js');
require('../../util/helpers/dom.js');
require('../../util/helpers/debounce.js');
require('../../util/helpers/throttle.js');
var functions = require('../../util/helpers/functions.js');
var magicSdk = require('@gig/magic-sdk');
require('../../util/helpers/session.js');
require('../../util/helpers/forms.js');
require('../../util/helpers/keys.js');
require('../../util/helpers/game.js');
require('../../util/helpers/game-category.js');
require('../../util/helpers/script.js');
require('../../util/helpers/events.js');
require('../../util/helpers/password.js');
require('../../util/helpers/storage.js');
require('../../util/helpers/theming.js');
require('../../util/helpers/objects.js');
require('../../util/helpers/slots.js');
require('../../util/helpers/phone.js');
require('../../util/validators/date-validator.js');
require('../../util/validators/debounce-validator.js');
require('../../util/types/input.js');
require('../../util/types/device.enum.js');
var magicMessages = require('@gig/magic-messages');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const makeFeatureDecorator = (valueGetter) => {
  return ({
    slug,
    default: defaultValue
  }) => Component.createDecorator((options, key) => {
    const subscriptions = [];
    const isDefaultFunction = typeof defaultValue === "function";
    const getDefault = (vm) => {
      if (isDefaultFunction) {
        return defaultValue.call(vm);
      }
      return defaultValue;
    };
    options.created = functions.hookFunction(options.created, function() {
      const updateValue = function() {
        return __async(this, null, function* () {
          this.$data[key] = yield valueGetter(slug, getDefault(this));
        });
      }.bind(this);
      updateValue();
      if (isDefaultFunction) {
        subscriptions.push(this.$watch(function() {
          return getDefault(this);
        }, updateValue));
      }
      subscriptions.push(window.eventBus.subscribe(magicMessages.LANGUAGE_UPDATED, () => updateValue()).unsubscribe);
      subscriptions.push(magicSdk.magic.events.sessionCreated(updateValue).unsub);
      subscriptions.push(magicSdk.magic.events.sessionDestroyed(updateValue).unsub);
      subscriptions.push(magicSdk.magic.events.userUpdated(updateValue).unsub);
    });
    options.beforeDestroy = functions.hookFunction(options.beforeDestroy, function() {
      subscriptions.forEach((unsub) => {
        unsub();
      });
    });
  });
};
const FeatureEnabledV2 = makeFeatureDecorator((slug) => __async(global, null, function* () {
  return yield getFeatureEnabled(slug);
}));
const FeatureValueV2 = makeFeatureDecorator((slug, defaultValue) => __async(global, null, function* () {
  return yield getFeatureValueV2(slug, defaultValue);
}));
const FeatureLocationV2 = makeFeatureDecorator((slug, defaultValue) => __async(global, null, function* () {
  const featureSetting = yield queryFeatureValue(slug, defaultValue);
  if (!featureSetting || !featureSetting.isApplicable) {
    return [];
  }
  return featureSetting.location;
}));
function queryFeatureValue(slug, defaultValue) {
  return window.queryBus.query(magicMessages.FEATURE_QUERY_VALUE, { slug, defaultValue });
}
function getFeatureValueV2(slug, defaultValue) {
  return __async(this, null, function* () {
    const featureSetting = yield queryFeatureValue(slug, defaultValue);
    if (!featureSetting || !featureSetting.isApplicable) {
      return defaultValue;
    }
    return featureSetting.value;
  });
}
function getFeatureEnabled(slug) {
  return __async(this, null, function* () {
    var _a;
    return (_a = yield window.queryBus.query(magicMessages.FEATURE_QUERY_ENABLED, slug)) != null ? _a : false;
  });
}
function getFeatureLocation(slug, defaultValue) {
  return __async(this, null, function* () {
    const featureSetting = yield queryFeatureValue(slug, defaultValue);
    if (!featureSetting || !featureSetting.isApplicable) {
      return defaultValue;
    }
    return featureSetting.location;
  });
}

exports.FeatureEnabledV2 = FeatureEnabledV2;
exports.FeatureLocationV2 = FeatureLocationV2;
exports.FeatureValueV2 = FeatureValueV2;
exports.getFeatureEnabled = getFeatureEnabled;
exports.getFeatureLocation = getFeatureLocation;
exports.getFeatureValueV2 = getFeatureValueV2;
